import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

const initialState = {
  caricamentoInCorso: false,
  scadenze: [],
  clienti: [],
  clientiConCodice: [],
};

const scadenzeSlice = createSlice({
  name: 'scadenze',
  initialState,
  reducers: {
    caricamento(state, action) {
      state.caricamentoInCorso = Boolean(action.payload);
    },
    aggiornaScadenze(state, action) {
      state.scadenze = action.payload;
    },
    aggiornaClienti(state, action) {
      state.clienti = _.uniq(action.payload);
    },
    aggiornaClientiConCodice(state, action) {
      state.clientiConCodice = action.payload;
    },
  },
});

export const { caricamento, aggiornaClienti, aggiornaScadenze, aggiornaClientiConCodice } = scadenzeSlice.actions;
const scadenzeReducer = scadenzeSlice.reducer;

export default scadenzeReducer;
